/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InviteMutationVariables = {|
  intentId: string
|};
export type InviteMutationResponse = {|
  +invite: boolean
|};
export type InviteMutation = {|
  variables: InviteMutationVariables,
  response: InviteMutationResponse,
|};
*/


/*
mutation InviteMutation(
  $intentId: ID!
) {
  invite(intentId: $intentId)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "intentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "intentId",
        "variableName": "intentId"
      }
    ],
    "kind": "ScalarField",
    "name": "invite",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InviteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InviteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2709a875d99706d4245a2cefa142b258",
    "id": null,
    "metadata": {},
    "name": "InviteMutation",
    "operationKind": "mutation",
    "text": "mutation InviteMutation(\n  $intentId: ID!\n) {\n  invite(intentId: $intentId)\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0ee334954ff971748931a37ab40cf84e';

module.exports = node;
